import React from "react";
import { Button, Col, FormControl, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  CustomerBean,
  CustomerSearchCriteria,
  FabricStyleSearchCriteria,
  InvoiceBean,
  InvoiceSearchCriteria,
  MultiDocumentMailInputInfo,
  PageListBean,
  RestCustomerListRequest,
  RestFabricStyleListBeanRequest,
  RestInvoiceListRequest,
  RestInvoiceSalesMultiInvoiceMailBeanRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGridColumnDefinition,
  DatePickerComponent,
  EditableDataGrid,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { InvoiceLookupHandlers } from "../lookup/InvoiceLookupHandlers.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { PopupInvoiceModule } from "../modules/ModuleUtil.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InvoiceService } from "../services/InvoiceService.js";
import CustomTable from "../gui_components/CustomTable.js";
class MailInvoice extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Mail Invoice",
      isShowExitButton: true,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isCriteriaFieldDisabled: false,
      criteria: new MultiDocumentMailInputInfo(),
      invCriteria: new InvoiceSearchCriteria(),
      customerData: new CustomerBean(),
      pageList: new RestPageListBean(),
      invoiceCriteriaList: [],
      selectedRowDataList: [],
      invoiceData: new InvoiceBean(),
      inquiryDataList: [],
      isInquiryDatasFound: false,
      invoiceLookupHandler: null,
      isShowInvoiceLookup: false,
      isShowMultipleInvoiceAddPopup: false,
      isShowLookUp: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      applyInvoicePageListForAutoCompleteList: new Array(),
      ShowAutoCompleteapplyInvoiceList: true,
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      isShowProgressBarPopup: false,
      moduleForPopup: [],
      isShowInvoiceModule: false,
      progressLoadingText: "",
      isShowFabricLookUp: true,
      isDisabled: false,
      isShowclearInvoice: false,
      isShowResetinvoice: false,
      isShowPopupAlert: false,
      is3PL: false,
    };
    this.invCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    ModuleUtils.getInvoiceStatusList();
    let criteria = this.state.criteria;
    criteria.from = "admin";
    this.initLookupHandlers();
    this.setFocus();
  }
  setFocus() {
    if (this.invCodeRef.current != null) {
      this.invCodeRef.current.focus();
    }
  }
  setClear() {
    let criteria = this.state.criteria;
    criteria.invoiceNumber = "";
    this.setState({ criteria: criteria });
    this.invCodeRef.current.clear();
    this.invCodeRef.current.focus();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "customerCode"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let invoiceLookupHandler = new InvoiceLookupHandlers(
      this.companyCode,
      "invoiceNumber"
    );
    this.setState({ invoiceLookupHandler: invoiceLookupHandler });
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  hideAlertPopUpCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowPopupAlert: isDisplayed, error_list: [] });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  invoiceonChange = (e) => {
    let invCriteria = this.state.invCriteria;
    invCriteria[e.target.name] = e.target.value;
    this.setState({ invCriteria: invCriteria });
  };
  errorCallBack = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: " ",
    });
  };
  clearCriteria = () => {
    let criteria = new MultiDocumentMailInputInfo();
    let invoiceData = new InvoiceBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.invoiceNumber = "";
    criteria.invoiceNumbers = [];
    this.setState({
      criteria: criteria,
      invoiceData: invoiceData,
      isShowInvoiceLookup: false,
      invoiceCriteriaList: [],
      selectedRowDataList: [],
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new MultiDocumentMailInputInfo();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.from = "admin";
    this.setState({
      criteria: criteria,
      invoiceCriteriaList: [],
      selectedRowDataList: [],
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
      isShowLookUp: true,
      isShowInvoiceLookup: false,
    });
    this.hideAlertCallBack();
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      let criteria = this.state.criteria;
      criteria.customerName = "";
      criteria.customerCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: false,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
      this.customerCleared();
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.loadCustomerBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ criteria: criteria });
  };
  loadCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
          customerData: customerData,
        });
      }
      this.customerSelected();
    }
  };
  loadCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.loadCustomerDetailResponse,
      this.errorCallBack
    );
  };
  loadCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.loadCustomerCodeResponse,
      this.errorCallBack
    );
  }
  loadCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.loadCustomerDetail(customerCode);
    this.loadMailDetails(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  loadMailDetails = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    if (SecurityAccessManager.MultiInvoiceMail_IsAccessible()) {
      InvoiceService.fetchMultiInvoicesMailDefaultInfoBean(
        input,
        this.loadCustomerDetailMailResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadCustomerDetailMailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.mailDefaultInfo != null) {
      let mailData = response.data.mailDefaultInfo;
      if (!isEmpty(mailData)) {
        criteria.from = mailData.from;
        criteria.tos = mailData.tos;
        criteria.ccs = mailData.ccs;
        criteria.title = mailData.title;
        criteria.message = mailData.message;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  customerSelected() {
    let criteria = this.state.criteria;
    let customerData = this.state.customerData;
    criteria.customerCode = customerData.code;
    criteria.customerName = customerData.description;
    let invoiceLookupHandler = new InvoiceLookupHandlers(
      this.companyCode,
      "InvoiceNumber",
      this.state.criteria.customerCode
    );
    this.setState({
      invoiceLookupHandler: invoiceLookupHandler,
      isShowInvoiceLookup: true,
      criteria: criteria,
    });
  }
  customerCleared() {
    let criteria = this.state.criteria;
    criteria.customerName = "";
    criteria.invoiceNumber = "";
    criteria.invoiceNumbers = [];
    criteria.from = "";
    criteria.tos = "";
    criteria.ccs = "";
    criteria.title = "";
    criteria.message = "";
    this.setState({
      invoiceLookupHandler: null,
      isShowInvoiceLookup: false,
      invoiceCriteriaList: [],
      selectedRowDataList: [],
      criteria: criteria,
    });
  }
  applyInvoiceOnChange = (e) => {
    let criteria = this.state.criteria;
    if (!isEmptyString(criteria.customerCode)) {
      let invoiceNumber = e.target.value;
      this.state.ShowAutoCompleteapplyInvoiceList = true;
      let ShowAutoCompleteapplyInvoiceList =
        this.state.ShowAutoCompleteapplyInvoiceList;
      if (isEmpty(invoiceNumber)) {
        let criteria = this.state.criteria;
        criteria.invoiceNumber = "";
        let suggestion = [];
        this.setState({
          ShowAutoCompleteapplyInvoiceList: false,
          criteria: criteria,
          invoiceData: new InvoiceBean(),
          applyInvoicePageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "invoiceNumber" &&
        ShowAutoCompleteapplyInvoiceList === true &&
        invoiceNumber !== ""
      ) {
        this.readapplyInvoiceBySearchString(e.target.value);
      }
      criteria[e.target.name] = e.target.value.toUpperCase();
      this.setState({ criteria: criteria });
    } else {
      let errMsg = "Customer Required!";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  applyInvoiceEnterKeyEvent = (e) => {
    let invoiceNumber = e.target.value;
    this.readInvoiceandDeatail(invoiceNumber);
    this.setState({
      applyInvoicePageListForAutoCompleteList: new Array(),
    });
  };
  displayapplyInvoiceAutoCompleteList = (showAutoCompleteList) => {
    this.setState({
      ShowAutoCompleteapplyInvoiceList: showAutoCompleteList,
    });
  };
  readapplyInvoiceBySearchString = (searchString) => {
    let inv_criteria = new InvoiceSearchCriteria();
    inv_criteria.companyCode = this.companyCode;
    inv_criteria.customerCode = this.state.criteria.customerCode;
    inv_criteria.invoiceNumberStartsWith = searchString;
    inv_criteria.invoiceNumberContains = searchString;
    let inv_pageList = new RestPageListBean();
    inv_pageList.pageSize = 100;
    let inv_requestInput = new RestInvoiceListRequest();
    inv_requestInput.pageInput = inv_pageList;
    inv_requestInput.searchCriteria = inv_criteria;
    InvoiceService.getInvoicePageList(
      inv_requestInput,
      this.loadApplyInvoicesResponse,
      this.errorCallBack
    );
  };
  readInvoiceandDeatail = (invoiceNumber) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = invoiceNumber;
    InvoiceService.readInvoice(
      readrestInput,
      this.loadInvoicesResponse,
      this.errorCallBack
    );
  };
  loadInvoicesResponse = (response) => {
    if (response.data.invoice != null) {
      let criteria = this.state.criteria;
      let invoice = response.data.invoice;
      criteria.invoiceNumber = invoice.code;
      let ShowAutoCompleteapplyInvoiceList = false;
      this.setState({
        criteria: criteria,
        invoiceData: invoice,
        ShowAutoCompleteapplyInvoiceList: ShowAutoCompleteapplyInvoiceList,
      });
    }
    this.hideAlertCallBack();
  };
  loadApplyInvoicesResponse = (response) => {
    if (
      response.data != null &&
      response.data.invoicePageList != null &&
      response.data.invoicePageList.invoices != null
    ) {
      let InvoiceData = response.data.invoicePageList.invoices;
      let simpleAutoCompleteList = new Array();
      if (InvoiceData.length > 0 && InvoiceData != null) {
        InvoiceData.map((obj) => {
          let simpleItemBean = {
            code: obj.code,
            description: "",
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
        this.setState({
          applyInvoicePageListForAutoCompleteList: simpleAutoCompleteList,
          //invoiceLookupHandler:simpleAutoCompleteList,
        });
      }
    }
    // else {
    //   let errMsg = "InValid InvoiceNumber!";
    //   let errList = [];
    //   errList.push(errMsg);
    //   this.setState({
    //     alertMessage: errList,
    //     alertType: "danger",
    //     isShowAlert: true,
    //   });
    // }
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  addInvoice = (e) => {
    this.setClear();
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.invoiceNumber = "";
    let invoiceCriteriaList = this.state.invoiceCriteriaList;
    let invoiceData = this.state.invoiceData;
    if (!isEmpty(invoiceData.code)) {
      if (!isEmptyArray(invoiceCriteriaList) && !isEmpty(invoiceData.code)) {
        let exists = invoiceCriteriaList.find(
          (p) => p.code === invoiceData.code
        );
        criteria.invoiceNumber = "";
        if (!exists) {
          invoiceCriteriaList.push(invoiceData);
          criteria.invoiceNumbers.push(invoiceData.code);
          criteria.invoiceNumber = "";
          this.setState({
            criteria: criteria,
            invoiceCriteriaList: invoiceCriteriaList,
          });
        }
      } else {
        if (!isEmptyString(invoiceData.code)) {
          invoiceCriteriaList.push(invoiceData);
          criteria.invoiceNumbers.push(invoiceData.code);
          criteria.invoiceNumber = "";
          this.setState({
            criteria: criteria,
            invoiceCriteriaList: invoiceCriteriaList,
          });
        }
      }
    }
  };
  addInvoiceMultiple = (e) => {
    if (e.detail == 1) {
      let criteria = this.state.criteria;
      let invoiceData = new InvoiceBean();
      let selectedRowDataList = this.state.selectedRowDataList;
      criteria.companyCode = this.companyCode;
      criteria.invoiceNumber = "";
      let invoiceCriteriaList = this.state.invoiceCriteriaList;
      let addMultiple = selectedRowDataList;
      if (!isEmptyArray(addMultiple)) {
        let invoiceNumbers = [];
        this.setState({
          invoiceCriteriaList: [],
        });
        invoiceCriteriaList = addMultiple;
        invoiceCriteriaList.map((p) => {
          invoiceNumbers.push(p.code);
        });
        criteria.invoiceNumbers = invoiceNumbers;
        criteria.invoiceNumber = "";
        this.setState({
          invoiceCriteriaList: invoiceCriteriaList,
          isShowMultipleInvoiceAddPopup: false,
          criteria: criteria,
          invoiceData: invoiceData,
        });
      } else {
        let errMsg = "No Line Selected!";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowPopupAlert: true,
        });
      }
    }
  };
  deleteInvoice = (val, line) => {
    let criteria = this.state.criteria;
    let invoiceData = new InvoiceBean();
    let invoiceNumbers = [];
    criteria.invoiceNumber = "";
    criteria.companyCode = this.companyCode;
    let lineData = criteria.invoiceNumbers;
    let invoiceCriteriaList = this.state.invoiceCriteriaList;
    invoiceCriteriaList.map((list, index) => {
      if (list.code === line.code) {
        lineData.splice(index, 1);
        invoiceCriteriaList.splice(index, 1);
        invoiceCriteriaList.map((p) => {
          invoiceNumbers.push(p.code);
        });
        criteria.invoiceNumbers = invoiceNumbers;
      }
    });
    this.setState({
      criteria: criteria,
      invoiceCriteriaList: invoiceCriteriaList,
      invoiceData: invoiceData,
    });
  };
  invoiceColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails("Invoice", "code", 0, true)
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "Remove",
          <DeleteIcon />,
          // true,
          1,
          false,
          null,
          false,
          null, //image link call back
          "1em", //min-width
          "20%", //max-width
          false,
          null,
          false
        )
        .setEditableDetails(
          false,
          "",
          null,
          true,
          this.deleteInvoice,
          false,
          null
        )
    );
    return columnList;
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowMultipleInvoiceAddPopup: isShowPopup,
    });
  };
  addMultiple = () => {
    let criteria = this.state.criteria;
    if (!isEmptyString(criteria.customerCode)) {
      let invCriteria = new InvoiceSearchCriteria();
      this.setState({
        criteria: criteria,
        isShowMultipleInvoiceAddPopup: true,
        selectedRowDataList: [],
        invCriteria: invCriteria,
        isDisabled: false,
        isShowLookUp: true,
        isShowFabricLookUp: true,
        isInquiryDatasFound: false,
        isShowResetinvoice: false,
        isShowclearInvoice: true,
      });
    } else {
      let errMsg = "Customer Required";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  selectAll = (e) => {
    if (e.detail == 1) {
      let list = this.state.inquiryDataList;
      list.map((line) => {
        line.isApplied = true;
      });
      this.setState({ selectedRowDataList: list });
    }
  };
  unSelectAll = (e) => {
    if (e.detail == 1) {
      let list = this.state.inquiryDataList;
      list.map((line) => {
        line.isApplied = false;
      });
      this.setState({ selectedRowDataList: [] });
    }
  };
  onSelectedChange = (e, rowData) => {
    rowData.isApplied = e.target.value;
    if (rowData.isApplied === true) {
      let selectedLine = this.state.selectedRowDataList;
      selectedLine.push(rowData);
      this.setState({ selectedRowDataList: selectedLine });
    } else {
      let checkLines = this.state.selectedRowDataList;
      let selectedLine = [];
      for (let line of checkLines) {
        if (line.isApplied != rowData.isApplied) {
          selectedLine.push(line);
          this.setState({ selectedRowDataList: selectedLine });
        } else if (this.state.selectedRowDataList.length == 1) {
          this.setState({ selectedRowDataList: [] });
        }
      }
    }
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let invCriteria = this.state.invCriteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      let invCriteria = this.state.invCriteria;
      invCriteria.fabricStyleCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: false,
        invCriteria: invCriteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.loadFabricBySearchString(e.target.value);
    }
    invCriteria[e.target.name] = e.target.value;
    this.setState({ invCriteria: invCriteria });
  };
  loadFabricStyleDetailResponse = (response) => {
    let invCriteria = this.state.invCriteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        invCriteria.fabricStyleCode = fabricStyle.code;
        invCriteria.fabricStyleName = fabricStyle.description;
        this.setState({
          invCriteria: invCriteria,
          fabricStyleData: fabricStyle,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  loadFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.loadFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  loadFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.loadFabricCodeResponse,
      this.errorCallBack
    );
  }
  loadFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.loadFabricStyleDetail(fabricStyleCode);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL
        ? "Reading Item"
        : "Reading FabricStyle",
    });
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  loadSearchInvoice = (e) => {
    if (e.detail == 1) {
      let criteria = this.state.criteria;
      let invCriteria = this.state.invCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Executing...",
      });
      invCriteria.companyCode = this.companyCode;
      invCriteria.customerCode = criteria.customerCode;
      let pageInput = new PageListBean();
      let listRequest = new RestInvoiceListRequest();
      listRequest.searchCriteria = invCriteria;
      listRequest.pageInput = pageInput;
      this.loadInvoiceList(listRequest);
    }
  };
  loadInvoiceList = (listRequest) => {
    InvoiceService.getInvoicePageList(
      listRequest,
      this.loadInvoicePageResponse,
      this.errorCallBack
    );
  };
  loadInvoicePageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.invoicePageList != null) {
      let resultList = new Array();
      if (!isEmptyArray(response.data.invoicePageList.invoices)) {
        resultList = response.data.invoicePageList.invoices;
      }
      this.setState({
        isShowclearInvoice: false,
        //isShowSearchInvoice:false,
        isShowResetinvoice: true,
        isShowFabricLookUp: false,
        isInquiryDatasFound: true,
        inquiryDataList: resultList,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisabled: true,
    });
  };
  getCaption = (status) => {
    return ModuleUtils.getInvoiceStatusCaption(status);
  };
  mailInvoiceColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isApplied", false)
        .setInputDetails(false, false, true, null, this.onSelectedChange, null)
        .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "code", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "createdDate", true, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer PO#", "customerPurchaseOrderNumber", true, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "invoiceStatus", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setStatusDetails(true, this.getCaption)
    );

    return columns;
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("", "isApplied", 0, false, null, false, null, "2em", "8%")
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.onSelectedChange
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Invoice",
        "code",
        0,
        true,
        this.viewInvoiceModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Customer Name", "customerName")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Date", "createdDate")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "CustomerPo",
        "customerPurchaseOrderNumber"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Status",
        "invoiceStatus",
        0,
        false,
        null,
        false,
        null,
        false,
        false,
        true,
        ModuleUtils.getInvoiceStatusCaption
      )
    );
    return columnList;
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewInvoiceModule = (e, code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowInvoiceModule: true,
        loadingText: "Executing",
        moduleForPopup: (
          <PopupInvoiceModule
            invoiceCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  clearInvoice = (e) => {
    if (e.detail == 1) {
      let invCriteria = new InvoiceSearchCriteria();
      invCriteria.companyCode = this.companyCode;
      this.setState({
        invCriteria: invCriteria,
      });
      this.hideAlertPopUpCallBack();
    }
  };
  resetInvoice = (e) => {
    if (e.detail == 1) {
      let invCriteria = new InvoiceSearchCriteria();
      invCriteria.companyCode = this.companyCode;
      this.setState({
        isShowclearInvoice: true,
        isShowFabricLookUp: true,
        isShowResetinvoice: false,
        isDisabled: false,
        invCriteria: invCriteria,
        isInquiryDatasFound: false,
        inquiryDataList: new Array(),
      });
      this.hideAlertPopUpCallBack();
    }
  };
  validateMailLine = (criteria) => {
    let isValidMailLine = false;
    let err_list = [];
    if (isEmpty(criteria.customerCode)) {
      let errMsg = " Invalid Customer!";
      err_list.push(errMsg);
    }
    if (isEmpty(criteria.invoiceNumbers)) {
      let errMsg = " Invalid Invoice Number";
      err_list.push(errMsg);
    }
    if (isEmpty(criteria.tos)) {
      let errMsg = "Invalid TOs";
      err_list.push(errMsg);
    }
    if (isEmpty(criteria.from)) {
      let errMsg = "Invalid From";
      err_list.push(errMsg);
    }
    if (err_list.length > 0) {
      isValidMailLine = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidMailLine = true;
      this.setState({ isShowAlert: false });
    }
    return isValidMailLine;
  };
  sendMail = () => {
    let criteria = this.state.criteria;
    let invoiceCode = this.state.invoiceData;
    let isValidLine = false;
    isValidLine = this.validateMailLine(criteria);
    if (isValidLine) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Sending Mail...",
      });
      let reportBean = new RestReportBean();
      let request = new RestInvoiceSalesMultiInvoiceMailBeanRequest();
      request.companyCode = this.companyCode;
      request.inputReportBean = reportBean;
      request.code = invoiceCode.code;
      request.infoBean = criteria;
      request.inputReportBean = reportBean;
      if (SecurityAccessManager.MultiInvoiceSendMail_IsAccessible()) {
        InvoiceService.sendSalesMultiInvoiceMail(
          request,
          this.sendMailResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  sendMailResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data.infos != null) {
      this.showInfoMessage(response.data);
      this.setState({
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        selectedRowDataList: [],
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  render() {
    let criteria = this.state.criteria;
    let invCriteria = this.state.invCriteria;
    let inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExitButton={this.state.isShowExitButton}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowResetButton={this.state.isShowResetButton}
          onModuleExit={this.onModuleExit}
          clearCriteria={this.clearCriteria}
          reset={this.resetInquiry}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          invoiceColumnDefinitions={this.invoiceColumnDefinitions}
          customerCodeOnChange={this.customerCodeOnChange}
          applyInvoiceOnChange={this.applyInvoiceOnChange}
          addInvoice={this.addInvoice}
          addMultiple={this.addMultiple}
          sendMail={this.sendMail}
          invCodeRef={this.invCodeRef}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          applyInvoiceEnterKeyEvent={this.applyInvoiceEnterKeyEvent}
          displayapplyInvoiceAutoCompleteList={
            this.displayapplyInvoiceAutoCompleteList
          }
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowInvoiceModule}
          popupLvlClass={"popupSizeLevel1"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowMultipleInvoiceAddPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel2"}
          title={"Find Rolls Details"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowPopupAlert}
              hideAlertCallBack={this.hideAlertPopUpCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                id="fabric_Add_Button"
                size="sm"
                onClick={(e) => this.addInvoiceMultiple(e)}
              >
                Add
              </Button>
            </div>
          }
          content={
            <div className="sales_line_pop">
              <Row>
                <Col sm="2">
                  <FormLabel>customer</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="customerCode"
                    placeholder="Customer"
                    onChange={this.onChange}
                    value={criteria.customerCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="4">
                  <InputTextbox
                    disabled={true}
                    name="customerName"
                    placeholder="Customer Name"
                    onChange={this.onChange}
                    value={criteria.customerName}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>Inv Start With</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="invoiceNumberStartsWith"
                    placeholder="invoiceNumberStartsWith "
                    onChange={this.invoiceonChange}
                    value={invCriteria.invoiceNumberStartsWith}
                    disabled={this.state.isDisabled}
                  />
                </Col>
                <Col sm="2">
                  <FormLabel>Inv Contains</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="invoiceNumberContains"
                    placeholder="invoiceNumberContains "
                    onChange={this.invoiceonChange}
                    value={invCriteria.invoiceNumberContains}
                    disabled={this.state.isDisabled}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>PO</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="customerPurchaseOrderNumber"
                    placeholder="customerPurchaseOrderNumber Name"
                    onChange={this.invoiceonChange}
                    value={invCriteria.customerPurchaseOrderNumber}
                    disabled={this.state.isDisabled}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>Inv Amt</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="invoiceGrandTotalAmount"
                    placeholder="invoiceGrandTotalAmount "
                    onChange={this.invoiceonChange}
                    value={invCriteria.invoiceGrandTotalAmount}
                    disabled={this.state.isDisabled}
                  />
                </Col>
                <Col sm="2">
                  <FormLabel>Inv Date</FormLabel>
                </Col>
                <Col sm="2">
                  <DatePickerComponent
                    name="invoiceDate"
                    placeholder="invoiceDate"
                    onChange={this.invoiceonChange}
                    value={invCriteria.invoiceDate}
                    disabled={this.state.isDisabled}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel> Status</FormLabel>
                </Col>
                <Col sm="2">
                  <FormControl
                    as="select"
                    name="invoiceStatus"
                    placeholder="invoiceStatus"
                    onChange={this.invoiceonChange}
                    value={invCriteria.invoiceStatus}
                    disabled={this.state.isDisabled}
                  >
                    <option></option>
                    <option value={"U"}>UnApproved</option>
                    <option value={"A"}>Approved</option>
                    <option value={"O"}>Open</option>
                    <option value={"P"}>Partially Paid</option>
                    <option value={"F"}>Paid</option>
                    <option value={"X"}>Cancelled</option>
                  </FormControl>
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    value={invCriteria.fabricStyleCode}
                    lookupRequired={this.state.isShowFabricLookUp}
                    showCriteriaDialog={true}
                    onChange={this.fabricCodeOnChange}
                    lookupHandler={this.state.fabricLookupHandler}
                    enterKeyEventHandler={this.fabricEnterKeyEventHandler}
                    autoCompleteListData={
                      this.state.fabricPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayAutoCompleteFabricList}
                    showAutoCompleteList={this.state.showAutoCompleteFabricList}
                    disabled={this.state.isDisabled}
                  />
                </Col>
                <Col sm="2"></Col>
                <Col sm="2">
                  {/* {this.state.isShowSearchInvoice && ( */}
                  <Button
                    id="fabric_Add_Button"
                    size="sm"
                    onClick={(e) => this.loadSearchInvoice(e, 1)}
                  >
                    Search Invoice
                  </Button>
                  {/* )} */}
                </Col>
                <Col>
                  {this.state.isShowclearInvoice && (
                    <Button
                      id="fabric_Add_Button"
                      size="sm"
                      onClick={(e) => this.clearInvoice(e)}
                    >
                      Clear
                    </Button>
                  )}
                </Col>
                <Col>
                  {this.state.isShowResetinvoice && (
                    <Button
                      id="fabric_Add_Button"
                      size="sm"
                      onClick={(e) => this.resetInvoice(e)}
                    >
                      Reset
                    </Button>
                  )}
                </Col>
              </Row>
              <div>
                {this.state.isInquiryDatasFound && (
                  <Row>
                    <Col sm="1">
                      <Button
                        id="fabric_Add_Button"
                        size="sm"
                        onClick={(e) => this.selectAll(e)}
                      >
                        SelectAll
                      </Button>
                    </Col>
                    <Col sm="1">
                      <Button
                        id="fabric_Add_Button"
                        size="sm"
                        onClick={(e) => this.unSelectAll(e)}
                      >
                        UnSelectAll
                      </Button>
                    </Col>
                  </Row>
                )}
              </div>
              {this.state.isInquiryDatasFound && (
                <div className="div_Custom_4">
                  {/* <EditableDataGrid
                    columnsList={this.columnDefinitions()}
                    dataList={inquiryDataList}
                  /> */}
                  <CustomTable
                    columns={this.mailInvoiceColumns()}
                    data={inquiryDataList}
                    label={"Invoice Lines"}
                  />
                </div>
              )}
            </div>
          }
        />
      </div>
    );
  }
}
export function CriteriaView(props) {
  let criteria = props.criteria;
  let customerCodeRef = props.customerCodeRef;
  let invCodeRef = props.invCodeRef;
  let customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  let applyInvoiceOnChange = (e) => props.applyInvoiceOnChange(e);
  let customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  let displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  let applyInvoiceEnterKeyEvent = (e) => {
    props.applyInvoiceEnterKeyEvent(e);
  };
  let displayapplyInvoiceAutoCompleteList = () => {
    props.displayapplyInvoiceAutoCompleteList();
  };
  let onChange = (e) => props.onChange(e);
  let invoiceColumnDefinitions = (e) => props.invoiceColumnDefinitions(e);
  let addInvoice = (e) => {
    if (e.detail == 1) props.addInvoice(e);
  };
  let addMultiple = (e) => {
    if (e.detail == 1) props.addMultiple(e);
  };
  let sendMail = (e) => {
    if (e.detail == 1) props.sendMail(e);
  };
  const textAreaStyle = {
    maxHeight: "9em",
    width: "32em",
    resize: "none",
    padding: "10px",
    boxSizing: "border-box",
    fontSize: "10px",
  };
  return (
    <div>
      <div class="row">
        <div className="col">
          <Row>
            <Col sm="1">
              <FormLabel> Customer </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={customerCodeRef}
                name="customerCode"
                placeholder="Customer"
                onChange={customerCodeOnChange}
                value={criteria.customerCode}
                lookupRequired={props.isShowLookUp}
                showCriteriaDialog={true}
                lookupHandler={props.customerLookupHandler}
                enterKeyEventHandler={customerCodeEnterKeyEventHandler}
                autoCompleteListData={props.customerPageListForAutoCompleteList}
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={displayAutoCompleteList}
                showAutoCompleteList={props.showAutoCompleteCustomerList}
                disabled={props.isDisableFields}
              />
            </Col>
            <Col sm="2">
              <InputTextbox
                disabled={true}
                name="customerName"
                placeholder="Customer Name"
                onChange={onChange}
                value={criteria.customerName}
              />
            </Col>
            {/* <Col sm="1"></Col> */}
            <Col sm="1">
              <FormLabel> Invoice </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={invCodeRef}
                onChange={applyInvoiceOnChange}
                name="invoiceNumber"
                value={criteria.invoiceNumber}
                lookupRequired={props.isShowInvoiceLookup}
                lookupHandler={props.invoiceLookupHandler}
                enterKeyEventHandler={applyInvoiceEnterKeyEvent}
                autoCompleteListData={
                  props.applyInvoicePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={displayapplyInvoiceAutoCompleteList}
                showAutoCompleteList={props.ShowAutoCompleteapplyInvoiceList}
              />
            </Col>
            <Col sm="3">
              <Button
                size="sm"
                id="fabric_Add_Button"
                onClick={(e) => addInvoice(e)}
              >
                Add
              </Button>
              {/* </Col>
            <Col sm="2"> */}
              <Button
                id="fabric_Add_Button"
                size="sm"
                onClick={(e) => addMultiple(e)}
              >
                Add Multiple
              </Button>
            </Col>
          </Row>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <Row>
            <Col sm="1">
              <FormLabel> From </FormLabel>
            </Col>
            <Col sm="6">
              <InputTextbox
                name="from"
                onChange={onChange}
                value={criteria.from}
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel> CCs </FormLabel>
            </Col>
            <Col sm="6">
              <InputTextbox
                name="ccs"
                onChange={onChange}
                value={criteria.ccs}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel> To </FormLabel>
            </Col>
            <Col sm="6">
              <InputTextbox
                name="tos"
                onChange={onChange}
                value={criteria.tos}
                isMandatory={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel> Tittle </FormLabel>
            </Col>
            <Col sm="6">
              <InputTextbox
                name="title"
                onChange={onChange}
                value={criteria.title}
                isMandatory={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="0.5">
              <FormLabel>Attachments</FormLabel>
            </Col>
            <Col sm="7">
              <textarea
                style={textAreaStyle}
                className="form-control"
                name="invoiceNumbers"
                value={criteria.invoiceNumbers}
                disabled={true}
              />
            </Col>

            <Col sm="3">
              <Button
                id="fabric_Add_Button"
                size="lg"
                onClick={(e) => sendMail(e)}
              >
                Send
              </Button>
            </Col>
          </Row>
          <Row>
            <Col sm="0.5">
              <FormLabel>Message</FormLabel>
            </Col>
            <Col sm="6">
              <textarea
                rows={13}
                cols={93}
                name="message"
                value={criteria.message}
                onChange={onChange}
              />
            </Col>
          </Row>
        </div>
        <div class="col-sm-6">
          <Row>
            <FormLabel className="table_title">Invoice Criteria List</FormLabel>
          </Row>
          <div className="div_Custom_mail">
            <EditableDataGrid
              columnsList={invoiceColumnDefinitions()}
              dataList={props.invoiceCriteriaList}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function MailInvoiceModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <MailInvoice {...props} name="" /> <br />
      </div>
    </div>
  );
}
export default MailInvoiceModule;
